import { Component, OnDestroy, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { AppNotificationService, AppNotificationType, CriticalityModel, CriticalityService } from '@evorait/pace-core';
import { catchError, finalize, of, Subject, takeUntil } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'pace-criticality',
    templateUrl: './criticality.component.html',
    styleUrls: ['./criticality.component.scss'],
    standalone: false,
})
export class CriticalityComponent implements OnInit, OnDestroy {
    public model: CriticalityModel;
    public criticalityForm: FormGroup;
    public formChildren: FormArray;
    public isSubmitting = false;

    private destroy$ = new Subject<void>();

    public constructor(
        private readonly modalInstance: BsModalRef,
        private readonly formBuilder: FormBuilder,
        private readonly criticalityService: CriticalityService,
        private readonly appNotificationService: AppNotificationService,
        private readonly translate: TranslateService,
    ) {}

    public ngOnInit(): void {
        this.formChildren = this.formBuilder.array([]);
        this.criticalityForm = this.formBuilder.group({
            formChildren: this.formChildren,
        });
    }

    public onCriticalityChange(): void {
        this.model.updateApproverAndWarningVisibility();
    }

    public closeModal(): void {
        this.modalInstance.hide();
    }

    public isChangeDisabled(): boolean {
        return (
            this.isSubmitting ||
            this.model.showWarning ||
            this.criticalityForm.invalid ||
            this.model.notificationEffectStatus === this.model.selectedEffectStatus
        );
    }

    public updateCriticality(): void {
        this.isSubmitting = true;
        this.criticalityService
            .submitCriticality(this.model)
            .pipe(
                takeUntil(this.destroy$),
                catchError((error) => {
                    this.appNotificationService.setAppNotification(
                        AppNotificationType.ERROR,
                        <string>this.translate.instant('NOTIFICATION_DETAILS_CRITICALITY_ERROR_TITLE'),
                        `${<string>this.translate.instant('NOTIFICATION_DETAILS_CRITICALITY_ERROR_BODY')} ${JSON.stringify(error)}`,
                    );

                    return of(undefined);
                }),
                finalize(() => (this.isSubmitting = false)),
            )
            .subscribe(() => this.closeModal());
    }

    public ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
